// Module
var code = "<div ng-if=\"$ctrl.state.tabData.length > 1\" class=\"c-searchTypeTabs\">\n    <inv-tab-panel tabs=\"$ctrl.state.tabData\" on-tab-selected=\"$ctrl.tabSelected\" on-changes=\"$ctrl.syncTabData\"></inv-tab-panel>\n</div>\n";
// Exports
module.exports = code;